<template>
    <div>
        <vapp-header btnBackToAllInvoices btnInvoiceOptions></vapp-header>
        <div class="container-guest">
            <div class="container">
                <router-link to="/invoice_details">
                    <div class="alert alert-dark" v-if="editInvoiceObj.status === 0">
                        <span>Invoice {{ editInvoiceObj.no }}</span>
                        <span class="float-right clearfix">DRAFT</span>
                    </div>

                    <div class="alert alert-primary" v-if="editInvoiceObj.status === 1">
                        <span>Invoice {{ editInvoiceObj.no }}</span>
                        <span class="float-right clearfix">PENDING REVIEW</span>
                    </div>

                    <div class="alert alert-success" v-if="editInvoiceObj.status === 2">
                        <span>Invoice {{ editInvoiceObj.no }}</span>
                        <span class="float-right clearfix">APPROVED</span>
                    </div>

                    <div class="alert alert-info" v-if="editInvoiceObj.status === 3">
                        <span>Invoice {{ editInvoiceObj.no }}</span>
                        <span class="float-right clearfix">ACCEPTED</span>
                    </div>

                    <div class="alert alert-danger" v-if="editInvoiceObj.status === 4">
                        <span>Invoice {{ editInvoiceObj.no }}</span>
                        <span class="float-right clearfix">VOIDED</span>
                    </div>

                    <div class="alert alert-warning" v-if="editInvoiceObj.status === 5">
                        <span>Invoice {{ editInvoiceObj.no }}</span>
                        <span class="float-right clearfix">RECEIVED</span>
                    </div>
                </router-link>

                <form class="form-fnc" autocomplete="off" @submit.prevent="submitInvoice">
                    <div class="row section-border">
                        <div class="col">
                            <label for="payment_term">Payment Term</label>
                            <select id="payment_term" class="custom-select padding-override"  @change="changeTerm" v-model="editInvoiceObj.term">
                                <option v-for="term in terms" :value="term" v-bind:key="term.id">{{ term && term.name }}</option>
                            </select>
                            <label for="currency">Currency Info</label>
                            <select id="currency" class="custom-select padding-override"  @change="changeCurrency" v-model="editInvoiceObj.currency">
                                <option disabled>Please select a currency</option>
                                <option v-for="currency in currencies" :value="currency" v-bind:key="currency.id"> {{ currency.code }}</option>
                            </select>
                        </div>
                        <div class="col">
                            <label>Invoice Date</label>
                            <vuejs-datepicker
                                    inputClass="vuejs-datepicker-style-override padding-override"
                                    calendarClass="vuejs-calendar-animation vuejs-calendar-style-override"
                                    v-model="editInvoiceObj.date">
                            </vuejs-datepicker>
                            <label v-if="editInvoiceObj.term && editInvoiceObj.term.name !== 'Cash'">Due Date</label>
                            <vuejs-datepicker v-if="editInvoiceObj.term && editInvoiceObj.term.name !== 'Cash'"
                                    inputClass="vuejs-datepicker-style-override padding-override"
                                    calendarClass="vuejs-calendar-animation vuejs-calendar-style-override"
                                    v-model="editInvoiceObj.due_date">
                            </vuejs-datepicker>
                        </div>
                    </div>

                    <div class="row section-border">
                        <div class="col-3">
                            <div class="add-customer" v-if="editInvoiceObj.status !== 2">
                                <router-link :to="{ name: 'select_contact', params: {cat: 'selectedContact'} }">
                                    <img class="img-responsive" src="@/assets/images/ic_add_customer.svg">
                                </router-link>
                            </div>
                            <div class="add-customer" v-else>
                                <img class="img-responsive" src="@/assets/images/ic_add_customer.svg">
                            </div>
                        </div>
                        <div class="col-3">
                            <div class="add-customer">
                                <router-link to="/select_item">
                                    <img class="img-responsive" src="@/assets/images/ic_add_item.svg">
                                </router-link>
                            </div>
                        </div>
                        <div class="col-3">
                            <div class="add-customer">
                                <router-link to="/select_account">
                                    <img class="img-responsive" src="@/assets/images/ic_add_service.svg">
                                </router-link>
                            </div>
                        </div>
                        <div class="col-3">
                            <div class="add-customer">
                                <img class="img-responsive" src="@/assets/images/ic_add_payment.svg" @click="navigateSelectPayment">
                            </div>
                        </div>
                    </div>

                    <!-- Customer -->
                    <div class="row section-border" v-if="editInvoiceObj.contact_id">
                        <div class="col-12" >
                            <div >
                                <ul class="customer-list" v-if="editInvoiceObj.status !== 2">
                                    <router-link  :to="{ name: 'select_contact', params: {cat: 'selectedContact'} }">
                                        <li>
                                            <div class="contact-circle">
                                                <span>{{ editInvoiceObj.contact_name.charAt(0) ? editInvoiceObj.contact_name.charAt(0) : '' }}</span>
                                            </div>
                                            <span>{{ editInvoiceObj.contact_name ? editInvoiceObj.contact_name : '' }}</span>
                                        </li>
                                    </router-link>
                                </ul>
                                <ul class="customer-list" v-else >
                                    <li>
                                        <div class="contact-circle">
                                            <span>{{ editInvoiceObj.contact_name.charAt(0) ? editInvoiceObj.contact_name.charAt(0) : '' }}</span>
                                        </div>
                                        <span>{{ editInvoiceObj.contact_name ? editInvoiceObj.contact_name : '' }}</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div v-if="editInvoiceObj.items && editInvoiceObj.items.length > 0" class="row section-border invoice-items">
                        <div class="col-12">
                            <div>
                                <ul class="customer-list item-list">
                                    <li v-for="(item, index) in editInvoiceObj.items" :key="index" class="clearfix">
                                        <!--<router-link :to="{ name: 'edit_item', params: { id: item.id } }">-->
                                        <div class="row item-top-row">
                                            <b v-if="item.account_id != null"> {{ item.quantity > 1 ? item.quantity : 1 }} Service</b>
                                            <b v-else> {{ item.quantity > 1 ? item.quantity : 1 }} Item</b>

                                            <img @click="removeItemEditInvoice(index)" src="@/assets/images/ic_delete.svg">
                                        </div>
                                        <div class="row">
                                            <div class="col">
                                                <span>{{ item.display_name ? item.display_name : item.name }} </span>
                                            </div>
                                            <div class="col">
                                                <span class="item-list float-right">{{ editInvoiceObj.currency && editInvoiceObj.currency.symbol }} {{ $numberWithCommas(item.unit_price * (item.quantity > 1 ? item.quantity : 1)) }}</span>
                                            </div>
                                        </div>
                                        <div class="row item-mid-row">
                                            <div class="col-1">
                                                <p><span>{{ item.quantity > 1 ? item.quantity : 1 }}</span></p>
                                            </div>
                                            <div class="col-3">
                                                <input type="number" id="unit_price" class="form-control padding-override inp-unit-price" v-model="item.unit_price">
                                            </div>
                                            <div class="col-1 custom-col">
                                                <img class="img-discount" src="@/assets/images/ic_discount.svg">
                                            </div>
                                            <div class="col-3">
                                                <input type="text" id="discount" class="form-control padding-override inp-discount" v-model="item.discount">
                                            </div>
                                            <div class="col-4 custom-col">
                                                <div class="col-quantity">
                                                    <img class="img-minus" src="@/assets/images/ic_minus.svg" @click="changeQuantityDecrement(index, item.quantity)">
                                                    <input readonly type="text" id="quantity" class="form-control padding-override inp-quantity" v-model="item.quantity">
                                                    <img class="img-plus" src="@/assets/images/ic_plus.svg" @click="changeQuantityIncrement(index, item.quantity)">
                                                </div>
                                            </div>
                                        </div>

                                       <div class="row" v-if="taxCodes && taxCodes.length > 0 ">
                                            <div class="col-7"></div>
                                            <div class="col-5 col-tax" v-if="taxCodes && taxCodes.length > 0">
                                                <select id="tax" class="custom-select padding-override" v-model="item.tax_code_id">
                                                    <option disabled>Select Tax</option>
                                                    <option v-for="tax in taxCodes" :value="tax" v-bind:key="tax.id"> {{ tax.code }} - {{ tax.rate }} %</option>
                                                </select>
                                            </div>
                                        </div>

                                        <div class="col-12" v-if="item.account_id">
                                            <div class="notes">
                                                <span>Name & Description</span>
                                                <textarea class="form-control" cols="30" rows="5" placeholder="Name & Description" v-model="item.name"></textarea>
                                            </div>
                                        </div>
                                        <!--</router-link>-->
                                        <div v-if="index !== editInvoiceObj.items.length - 1" class="row section-border" style="margin-bottom:20px"></div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>


                    <!-- Payment -->
                    <div  class="row section-border" v-if="editInvoiceObj.partials && editInvoiceObj.partials.length > 0">
                        <div class="col-12">
                            <div>
                                <ul class="customer-list item-list">
                                    <li v-for="(payment, index) in editInvoiceObj.partials" v-bind:key="payment.id"  class="clearfix" v-if="!payment.is_deleted">
                                        <div class="row" style="padding-left: 15px; margin-top: -10px; padding-bottom:5px">
                                            <b>1 Payment</b>
                                            <img  @click="removePaymentEditInvoice(index)"  style="position: absolute;right: 0;margin-right: 10px" src="@/assets/images/ic_delete.svg">
                                        </div>
                                       <div class="row">
                                            <div class="col-6" v-if="payment.method_id">
                                                <span>{{ payment.method_name}}</span>
                                            </div>
                                            <div class="col-6" v-if="payment.method_id">
                                                <span style="position: absolute;right: 0;margin-right: 10px"><b>{{ editInvoiceObj.currency && editInvoiceObj.currency.symbol }} {{ $numberWithCommas(payment.amount) }}</b></span>
                                            </div>
                                        </div>
                                        <div class="row" style="margin-bottom:8px">
                                            <div class="col-6" v-if="payment.method_id">
                                                <span>{{ payment.account_name}}</span>
                                            </div>
                                        </div>
                                        <div v-if="index !== editInvoiceObj.partials.length - 1" class="row section-border" style="margin-bottom:20px"></div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12">
                            <div class="notes">
                                <span>Notes</span>
                                <textarea class="form-control" id="" cols="30" rows="5" placeholder="Additional notes to your customer" v-model="editInvoiceObj.memo"></textarea>
                            </div>
                        </div>
                    </div>
                </form>

                <div class="invoice-buttons row">
                    <div class="col-6">
                        <div class="row">
                            <b style="padding-bottom: 7px">GRAND TOTAL</b>                        
                        </div>
                        <div class="row">
                            <span style="font-size: x-large;">{{ editInvoiceObj.currency && editInvoiceObj.currency.symbol }} {{ $numberWithCommas( grandTotal) }}</span>
                            <img @click="showDialog = true" style="width: 10%;transform: rotate(180deg);margin-left: 15px;margin-top: -10px" src="@/assets/images/sh-icon-arrow-down.svg">
                        </div>
                    </div>
                    <div class="col-6">
                        <button class="btn btn-block btn-fnc" @click="previewInvoice">Preview</button>
                    </div>
                </div>
                <embed v-bind:src="pdfSrc" width="800px" height="2100px" />
            </div>
        </div>
        <md-dialog :md-active.sync="showDialog">
            <div class="col-12">
                <div class="subtotal">
                    <span>Subtotal</span>
                    <span class="float-right">{{ editInvoiceObj.currency && editInvoiceObj.currency.symbol }} {{ $numberWithCommas(subTotal) }}</span>
                </div>
                <div class="subtotal" v-if="taxTotal > 0">
                    <span>Tax</span>
                    <span class="float-right">{{ editInvoiceObj.currency && editInvoiceObj.currency.symbol }} {{ $numberWithCommas(taxTotal) }}</span>
                </div>
                <div class="subtotal">
                    <span>Grand Total</span>
                    <span class="float-right">{{ editInvoiceObj.currency && editInvoiceObj.currency.symbol }} {{ $numberWithCommas(grandTotal) }}</span>
                </div>
                <div class="subtotal">
                    <span>Balance</span>
                    <span class="float-right">{{ editInvoiceObj.currency && editInvoiceObj.currency.symbol}} {{ $numberWithCommas(balance) }}</span>
                </div>
                <div class="subtotal"  v-if="grandTotal - subTotal < 0">
                    <span>Discount</span>
                    <span class="float-right">{{ editInvoiceObj.currency && editInvoiceObj.currency.symbol }} {{ $numberWithCommas(grandTotal - subTotal) }}</span>
                </div>                
            </div>
            <md-dialog-actions>
                <md-button class="md-primary" @click="showDialog = false">Close</md-button>
            </md-dialog-actions>
        </md-dialog>
    </div>
</template>

<script>
    import { mapState, mapActions } from 'vuex'
    import * as $$ from "lodash";
    import { IntegerPlusminus } from 'vue-integer-plusminus';
    import currencySvc from '../../services/currencyService';
    import listSvc from '../../services/listService';
import { constants } from 'crypto';

    export default {
        name: "EditInvoice",
        components: {
            IntegerPlusminus
        },
        data: function() {
            return {
                date: null,
                due_date: null,
                due_date_text: '',
                selectedPaymentTerm:'',
                company_id: null,
                invoice_payment_subtotal: null,
                terms: null,
                methods: null,
                method_id:null,
                account_id:null,
                memo: null,
                originalInvoice: Object,
                pdfSrc: '',
                is_cash_term: false,
                baseCurrency: {},
                invoice: {},
                currencies: [],
                invoice_currency : null,
                showDialog: false,
                taxCodes: []
            };
        },
        computed: {
            ...mapState('invoice',['editInvoiceObj']),
            ...mapState('company',['selectedCompany']),
             taxTotal () {
                let tax = 0;
                $$.each(this.editInvoiceObj.items, (item) => {
                    if (item.tax_code_id) {
                        tax += item.unit_price * (item.tax_code_id.rate / 100);
                    }
                });
                return tax;
            },
            paymentTotal : function() {
                let paymentTotal = 0;
                $$.each(this.payments, function(payment) {
                    paymentTotal += parseFloat(payment.amount)
                });
                return paymentTotal;
            },
            paymentTotal : function() {
                let paymentTotal = 0;
                $$.each(this.payments, function(payment) {
                    paymentTotal += parseFloat(payment.amount)
                });
                return paymentTotal;
            },
            subTotal: function() {
                let subTotal = 0;
                $$.each(this.editInvoiceObj.items, (item) => {
                    subTotal += item.unit_price * item.quantity;
                });
                return subTotal
            },
            grandTotal: function() {
                let grandTotal = 0;
                $$.each(this.editInvoiceObj.items, (item) => {
                    var currentTotal = item.unit_price * item.quantity;
                    if (item.discount !== undefined) {
                        var discountFormat = item.discount;
                        if (discountFormat.includes('%')) {
                            var discount = discountFormat.slice(0, -1);
                            currentTotal = currentTotal - (currentTotal * (discount/100))
                        } else {
                            currentTotal = currentTotal - (currentTotal * (item.discount/100))
                        }
                    }

                    if (item.tax_code_id) {
                        currentTotal = currentTotal + (item.tax_code_id.rate / 100) * currentTotal
                    }

                    grandTotal += currentTotal;
                });
                return grandTotal;
            },
            balance: function() {
                let balance = 0;
                let totalPayment = 0;
                 $$.each(this.editInvoiceObj.partials, (partial) => {
                    totalPayment += partial.amount;
                });
                balance = totalPayment - this.grandTotal;
                this.setPaymentAmount(Math.abs(balance));
                return balance;
            },
            // requestData: function() {
            //     this.due_date_text = this.selectedPaymentTerm.name
            //     var date = this.$moment(this.date);

            //     let invoiceData = {
            //         // contact_id: this.selectedContact.id,
            //         // date: date.format("YYYY-MM-DD"),
            //         // term_id: this.selectedPaymentTerm.id,
            //         // is_cash_term: true,
            //         // no: this.invoice.no,
            //         // currency_id: this.invoice.currency_id,
            //         // currency_rate: this.invoice.currency_rate,
            //         // tax_inclusive: false,
            //         // status: this.status,
            //         // memo: this.memo,
            //         // items: this.items_array,
            //         // partials: this.partials_array,
            //         // tags: []
            //     };

            //     if (this.due_date_text !== "Cash"){
            //         // invoiceData.is_cash_term = false;
            //         // invoiceData.due_date = this.due_date;
            //         // invoiceData.partials = [];
            //     }

            //     console.log("InvoiceData",invoiceData)
            //     return invoiceData;
            // },
            // invoice_id: function() {
            //     return  this.$store.state.invoice_obj.id
            // },
            // items_array: function() {
            //     let itemsArr = [];
            //     $$.each(this.items, function (item, index) {
            //         let itemToPush = {
            //             id: item.id,
            //             product_id: item.product_id ? item.product_id : null,
            //             name: item.name,
            //             quantity: item.quantity,
            //             line: index + 1,
            //             unit_price: item.unit_price ? item.unit_price : item.sale_price,
            //             account_id: item.account_id ? item.account_id : null,
            //         };
            //         if (item.is_deleted) {
            //             itemToPush = {};
            //             itemToPush.id = item.id;
            //             itemToPush.is_deleted = item.is_deleted;
            //         }
            //         itemsArr.push(itemToPush)
            //     });
            //     return itemsArr;
            // },
            // partials_array: function () {
            //     let paymentsArr = [];
            //     $$.each(this.payments, function(payment) {
            //         paymentsArr.push({
            //             method_id: payment.method_id,
            //             account_id: payment.account_id,
            //             amount: payment.amount
            //         });
            //     });
            //     return paymentsArr;
            // },

        },
        methods: {
             ...mapActions('invoice',['setEditInvoiceObj', 'removeItemEditInvoice', 'setCurrentPaymentLine', 'removePaymentEditInvoice', 'changeItemDescription', 'changeItemDiscount', 'changeItemUnitPrice', 'setPaymentAmount', 'changeItemQuantityEditInvoice']),
            // new method
            changeTerm (){
                console.log("change Term");
                let isCashTerm = false;

                this.$store.dispatch('invoice/setEditInvoiceObj', { 
                    term : this.editInvoiceObj.term,
                });
                this.$store.dispatch('invoice/setEditInvoiceObj', { 
                    due_date:  this.$moment().add(this.editInvoiceObj.term.day, 'days').format("YYYY-MM-DD")
                });

                if (this.editInvoiceObj.term.name === 'Cash') {
                    isCashTerm = true;
                }
                this.$store.dispatch('invoice/setEditInvoiceObj', { 
                    is_cash_term: isCashTerm
                });
            },
            //new method
            changeCurrency(){       
                console.log("change Currency");         
                let config = {
                    params : {
                        company_id : this.selectedCompany,
                        from_currency_id: this.createInvoiceObj.currency.id,
                        to_currency_id: this.baseCurrency.id,
                        date: new Date()
                    }
                };

                currencySvc.methods.getCurrencyRate(config)
                    .then(response => {
                        this.$store.dispatch('invoice/setCreateInvoiceObj', { 
                            currency_rate: response.rate.rate,
                        });
                    });
            },
            changeQuantityIncrement(itemIndex, quantity){
                let data = {
                    index: itemIndex,
                    quantity: quantity + 1,
                };
                this.changeItemQuantityEditInvoice(data);
            },
            changeQuantityDecrement(itemIndex, quantity) {
                let data = {
                    index: itemIndex,
                    quantity: quantity - 1,
                };
                this.changeItemQuantityEditInvoice(data);
            },
            //new method
            navigateSelectPayment () {
                if (this.editInvoiceObj.partials === undefined) {
                    this.setCurrentPaymentLine(1);
                } else {
                    this.setCurrentPaymentLine(this.editInvoiceObj.partials.length + 1);
                }
                this.$router.push('/select_payment')
            },
            getRate(){
                this.$root.$emit('show-loading', true);
                let config = {
                    params : {
                        company_id : this.company_id,
                        from_currency_id: this.invoice.currency_id,
                        to_currency_id: this.baseCurrency.id,
                        date: new Date()
                    }
                };
                currencySvc.methods.getCurrencyRate(config).then(data => {
                    this.invoice.currency_rate = data.rate.rate;
                    this.invoice_currency = this.findCurrencyById(this.invoice.currency_id).symbol;
                });
            },
            findCurrencyById(currency_id) {
                let tempCurrency = {};
                $$.each(this.currencies, function (currency) {
                    if (currency.id === currency_id){
                        tempCurrency = currency;
                    }
                });
                return tempCurrency;
            },
            removeItemLine(itemIndex, item) {
                let data = {
                    index : itemIndex,
                    id : item.id,
                };
                if (item.id !== undefined){
                    this.$store.dispatch('setItemLineIsDeleted', data)
                } else {
                    this.$store.dispatch('removeItem', itemIndex)
                }
            },
            
            // selectPaymentDate() {
            //     if(this.selectedPaymentTerm.name === 'Cash') {
            //         this.due_date = this.date
            //     } else if(this.selectedPaymentTerm.name  === 'Due on Receipt') {
            //         this.due_date = this.date
            //         this.$store.dispatch('clearPayments');
            //     } else if(this.selectedPaymentTerm.name  === 'Net 15') {
            //         this.due_date = this.$moment().add(15, 'days').format("YYYY-MM-DD")
            //         this.$store.dispatch('clearPayments');
            //     } else if(this.selectedPaymentTerm.name  === 'Net 30') {
            //         this.due_date = this.$moment().add(30, 'days').format("YYYY-MM-DD")
            //         this.$store.dispatch('clearPayments');
            //     } else if(this.selectedPaymentTerm.name  === 'Net 60') {
            //         this.due_date = this.$moment().add(60, 'days').format("YYYY-MM-DD")
            //         this.$store.dispatch('clearPayments');
            //     } else if(this.selectedPaymentTerm.name  === 'Progress Payment') {
            //         this.due_date = this.$moment().add(100, 'days').format("YYYY-MM-DD")
            //         this.$store.dispatch('clearPayments');
            //     }
            //     this.$store.dispatch('setEditInvoiceTerm', this.selectedPaymentTerm);
            // },
            // goToSelectContact() {
            //     this.$store.dispatch('set_invoice_obj', this.requestData);
            //     this.$router.push({ name: 'select_contact', params: {} })
            // },
            // goToItem() {
            //     this.$store.dispatch('set_invoice_obj', this.requestData)
            // },
            personaliseInvoice() {
                this.$store.dispatch('set_invoice_obj', this.requestData);
                this.$router.push({ name: 'invoice_personalization', params: {} })
            },
            previewInvoice() {
                this.$router.push('/preview_pdf')
                // this.$root.$emit('show-loading', true);
                // let id = this.$store.state.invoice_obj.id;
                // let encryptedToken  = this.$store.state.sessions.encrypted_token;
                // console.log(encryptedToken);
                // this.axios
                //     .get("/sales/invoices/" + id + "/pdf?" + "t="+ encryptedToken +"&k=a1cab95df79930fa63947a2bc6f746dd")
                //     .then(response => {
                //         this.$root.$emit('show-loading', false);
                //         // var wordArray = cryptojs.enc.Utf8.parse(response.data)
                //         // var base64 = cryptojs.enc.Base64.stringify(wordArray)
                //         // console.log("PDF Data: ",base64)
                //         let encodedData = response.data;
                //         let pdfWindow = window.open("");
                //         pdfWindow.document.write("<iframe width='100%' height='100%' src='data:application/pdf;base64, " + encodeURI(encodedData) + "'></iframe>")
                //         console.log(escape(response.data))
                //     })
                //     .catch(error => {
                //         this.$root.$emit('show-loading', false);
                //         this.$generalAPIErrorHandling(error, this.$router);
                //     })
            },

            // setInvoiceData (invoiceObj){
            //     this.invoice = invoiceObj;
            //     this.date = invoiceObj.date;
            //     this.invoice.term_id = invoiceObj.term_id;
            //     this.due_date = invoiceObj.due_date;
            //     this.invoice.currency_id = invoiceObj.currency.id;
            //     this.invoice_currency = invoiceObj.currency.symbol;
            //     this.status = invoiceObj.status;
            //     this.memo = invoiceObj.memo;
            // },
            readMixed () {
                let postData = {
                    "requests":[
                        {
                            "uri" : "/lists/terms",
                            "params": {
                                "company_id": this.selectedCompany
                            }

                        },
                        {
                            "uri" : "/lists/currencies",
                            "params": {
                                "company_id": this.selectedCompany
                            }
                        },
                        {
                            "uri" : "/lists/tax_codes",
                            "params": {
                                "company_id": this.selectedCompany,
                                "is_sale_tax": true,
                                "date" : Date.now()
                            }
                        },
                    ]
                };

                listSvc.methods.readMixed(postData).then(data => {
                    this.terms = data.terms;
                    this.taxCodes = data.tax_codes;
                    $$.each(data.currencies, (currency) => {
                        if (currency.is_primary){
                            this.baseCurrency = currency;
                        }
                        this.currencies.push(currency);
                        if (currency.id === this.editInvoiceObj.currency.id){
                            this.$store.dispatch('invoice/setEditInvoiceObj', { 
                                currency : currency
                            });
                        }
                    });

                    $$.each(this.terms, (term) => {
                        if (term.id === this.editInvoiceObj.term_id){
                            this.$store.dispatch('invoice/setEditInvoiceObj', { 
                                term : term
                            });
                        }
                    });

                    $$.each(this.taxCodes, (taxCode) => {

                        $$.each(this.editInvoiceObj.items, (item, index) => {
                            if (taxCode.id === item.tax_code_id){
                                this.editInvoiceObj.items[index].tax_code_id = taxCode;
                            }
                        })
                        
                    });
                });
            }

        },
        mounted() {
            console.log("Mounted : Edit Invoice");
            //Set invoice being edited to original invoice (for discard changes purpose)
            // this.originalInvoice = this.invoice_obj;

            // // Set invoice data
            // this.company_id = this.$store.state.selected_company;
            // this.setInvoiceData(this.$store.state.invoice_obj);

            // // On Discard Changes
            // this.$root.$on('discardInvoiceChanges', () => {
            //     // reset contact data
            //     let contact = {
            //         name: this.originalInvoice.contact_name
            //     };
            //     this.$store.dispatch('selectContact', contact);
            //     this.$store.dispatch('selectDepositToContact', contact);
            //     // reset memo
            //     this.memo = this.originalInvoice.memo;
            //     // reset items
            //     this.$store.dispatch('setItems', this.originalInvoice.items);
            //     this.$store.dispatch('setPayments', this.originalInvoice.partials);
            // });

            this.readMixed();
            // console.log(this.editInvoiceObj.partials);
            // let payments = []
            //     $$.each(this.editInvoiceObj.partials, (payment)=> {
            //         if (!payment.is_deleted) {
            //             payments.push(payment)
            //         }
            //     });
            //     console.log(payments);
            //     // return payments;

        }
    };
</script>

<style scoped lang="scss">

    /* Invoice Title */
    .alert {
        margin: 15px 0 15px 0;
    }

    .invoice-items {
        .item-top-row {
            padding-left: 15px; 
            margin-top: -10px; 
            padding-bottom:5px;
            img {
                position: absolute;right: 0;margin-right: 10px
            }
        }
        .item-mid-row {
            .custom-col {
                padding-left:0px; 
                padding-right:0px;
                
                .col-quantity {
                    position: absolute;
                    right: 0;
                    margin-right: 10px;

                    .img-minus {
                        width:15px; 
                        margin-right: 10px;
                    }

                    .img-plus {
                        width:15px; 
                        margin-left: 10px;
                    }
                }
            }
            .inp-unit-price {
                border-radius: 5px !important; 
                height: 35px; 
                font-size: smaller;
            }
            .img-discount {
                width:25px; 
                display:block;
                display: block;
                margin-right: auto;
                margin-left: auto;
            }
            .inp-discount {
                border-radius: 5px !important; 
                height: 35px;
            }
            .inp-quantity {
                border-radius: 5px !important; 
                height: 35px; width:40px; 
                display:-webkit-inline-box
            }
        }
    }
    .md-dialog {
        height: 250px;
        width: 100px;
        margin-bottom: 30%;
    }

    /* Invoice Title */
    .alert {
        margin: 15px 0 15px 0;
    }

    .section-border {
        border-bottom: 10px solid rgba(68, 43, 43, 0.1);
    }

    input,
    select {
        margin-bottom: 15px;
    }

    .payment-date-dialog {
        background-color: white;
        top: 50%;
        transform: translateY(-50%);
        max-width: 768px;
        border-radius: 3px;
        padding: 5px;
        margin: 5px;
        height: 185px;

        .md-field {
            width: calc(100% - 50px) !important;
            margin-left: auto !important;
            margin-right: auto !important;
        }
    }

    /* Add Customer Button */
    .add-customer {
        cursor: pointer;

        a {
            text-decoration: none;
        }

        img {
            width: 40px;
            display: block;
            margin-left: auto;
            margin-right: auto;
            margin-top: 10px;
            margin-bottom: 10px;
        }

        span {
            font-weight: 500;
            color: #05d2c5;
        }
    }

    .customer-list {
        padding-left: 0;
        margin-bottom: 0;

        a {
            text-decoration: none;
            color: inherit;
            li {
                .contact-circle {
                    background: #24cab7;
                    border-radius: 50%;
                    border: 1px solid rgba(0, 0, 0, 0.1);
                    margin-right: 15px;
                    display: inline-block;
                    width: 50px;
                    height: 50px;
                    text-align: center;

                    span {
                        color: white;
                        text-transform: lowercase;
                        line-height: 43px;
                        font-size: 1.25rem;
                    }
                }
            }
            span {
                transition: all 0.3s ease-in-out;
            }
        }

        li {
            .contact-circle {
                background: #24cab7;
                border-radius: 50%;
                border: 1px solid rgba(0, 0, 0, 0.1);
                margin-right: 15px;
                display: inline-block;
                width: 50px;
                height: 50px;
                text-align: center;

                span {
                    color: white;
                    text-transform: lowercase;
                    line-height: 43px;
                    font-size: 1.25rem;
                }
            }
        }
        span {
            transition: all 0.3s ease-in-out;
        }

        li {
            cursor: pointer;
            list-style: none;
            padding: 0 0 15px 0;
            transition: all 0.3 ease-in-out;

            img {
                width: 15px;
            }
        }
    }

    .item-list {
        li {
            padding-bottom: 0;
        }

        p {
            margin-top: 7px;
            span {
                color: #8aa2b2;
            }

            span:nth-of-type(1) {
                background-color: #8aa2b2;
                border-radius: 4px;
                color: white;
                font-weight: 600;
                padding: 1px 5px;
            }
        }
    }

    .item-list.float-right {
        font-weight: 500;
    }

    /* Subtotal / Divider / Due  */
    .subtotal {
        padding: 20px 0;
    }

    .divider {
        height: 1px;
        width: 100%;
        background-color: rgba(0, 0, 0, 0.5);
    }

    .notes {
        textarea {
            margin-top: 10px;
            margin-bottom: 75px;
            border-color: #05d2c5;
            border-radius: 10px;
            padding: 15px;
        }
    }
    .md-card {
    width: 320px;
    margin: 4px;
    
    vertical-align: top;
    margin-left: auto;
    margin-right: auto;
    display: block;
  }

    .due {
        padding: 20px 0 20px 15px;
        background-color: #e4f5fc;
        margin-bottom: 15px;

        .custom-select {
            width: 125px;
            margin-bottom: 0;
            background-color: transparent;
            border: none;
            padding-left: 0;
        }

        span {
            margin-top: 10px;
            margin-right: 15px;
        }

        span:nth-of-type(2) {
            font-weight: 500;
        }

        img {
            width: 12px;
        }
    }

    .selected {
        border-radius: 3px;
    }

    .invoice-buttons {
        position: fixed;
        bottom: 0;
        min-width: 100%;
        padding-left: 25px;
        padding-right: 25px;
        right: 0;
        left: 0;
        padding-top: 15px;
        padding-bottom: 15px;
        background-color: #e4f5fc;
        border-top: 1px solid rgba(0, 0, 0, 0.1);
        z-index: 10;

        .btn {
            text-transform: uppercase;
        }

        .btn-fnc-override {
            background-image: none;
            background-color: white;
            border: 1px solid #6b7377;
            color: #6b7377;
        }
    }

    .checkAppear {
        margin-right: 10px;
    }

    .slideInRight {
        animation: slideInRight 0.3s ease-in-out;
        animation-fill-mode: forwards;
    }

    .slideOutLeft {
        animation: slideOutLeft 0.3s ease-in-out;
        animation-fill-mode: forwards;
    }

    @keyframes slideInRight {
        0% {
            transform: translateX(-25px);
            opacity: 0;
        }

        100% {
            transform: translateX(0px);
            opacity: 1;
        }
    }

    @keyframes slideOutLeft {
        0% {
            transform: translateX(0px);
            opacity: 1;
        }

        100% {
            transform: translateX(-25px);
            opacity: 0;
        }
    }

    .col-tax {
        select {
            border-radius: 5px !important;
            height: 35px;
            background: #FFF url(/img/sh-icon-arrow-down.34015d80.svg) no-repeat right 1rem center;
            background-size: 15px
        }
    }
    .form-control:disabled, .form-control[readonly] {
    background-color: white;
    opacity: 1;
    }
</style>
